import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';
import { DialogW9formComponent, IDataW9Form } from '../dialog/dialog-w9form.component';
import { DialogPaformComponent, IDataPaymentAuthorizationForm } from '../dialog/dialog-paform.component';
import { DialogSubmitComponent } from '../dialog/dialog-submit.component';
import { DialogConfirmSubmissionComponent } from '../dialog/dialog-confirm-submission.component';

import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';

import {
  AuthenticationService,
  ApplicationApiService,
  ApprovalTaskItemApiService,
  ApplicationPaymentApiService,
  ContactApiService,
  ApplicationEventApiService
} from '../../data-services/index';

import {
  IApplication, IApplicationInput, IApplicationEventInput,
  IApplicationPayment, IApplicationPaymentInput,
  IApprovalTask, IApprovalTaskItem, IApprovalTaskItemInput,
  IContact, IUser, IHelp, HelpApiService, IOptionSets, IOptions, ContractorApiService
} from '@ebb-v2/ebb-integration';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { cloneDeep } from '@apollo/client/utilities';

@Component({
  selector: 'ebb-portal-review',
  templateUrl: './review.component.html',
  styles: []
})
export class ReviewComponent implements OnInit, OnChanges {
  @Input('application') application: IApplication;
  @Input('listHelp') listHelp: IHelp[];
  @Input('listOptionSets') listOptionSets: IOptionSets[];
  @Output() emitEventContractorChange = new EventEmitter<IApplicationInput>();
  @Output() emitPermitInfoChangeEvent = new EventEmitter<IApplicationInput>();
  @Output() emitReceiptsPreInfoChangeEvent = new EventEmitter<IApplicationInput>();
  @Output() emitDataFormChangeEvent = new EventEmitter<IApprovalTask>();
  @Output() emitFileChangeEvent = new EventEmitter<IApprovalTask>();
  @Output() emitSubmitApplication = new EventEmitter<boolean>();
  
  public currentUser: IUser;

  // Application Data
  public applicationOwner: IContact = null;
  public applicationContractor: IContact = null;
  public applicationPayment: IApplicationPayment = {} as IApplicationPayment;

  // Approval Task Data
  public taskRetrofitContractorTitle = 'Contractor Information';
  public taskRetrofitContractorStatus = 'Pending';
  public taskRetrofitContractorSummary = 'Select who will do the retrofit';

  public taskBuildingPermit: IApprovalTask;
  public taskPermitSignoff: IApprovalTask;
  public taskHousePhotosPre: IApprovalTask;
  public taskHousePhotosPost: IApprovalTask;
  public taskCrawlspacePhotosPre: IApprovalTask;
  public taskCrawlspacePhotosPost: IApprovalTask;
  public taskHeaterPhotos: IApprovalTask;
  public taskReceiptsPre: IApprovalTask;
  public taskReceiptsPost: IApprovalTask;
  public taskW9form: IApprovalTask;
  public taskPaymentAuthorization: IApprovalTask;

  public programHasHousePhotos = false;

  public w9FormId = '';
  public w9FormPayee = '';
  public w9FormSubmitted = false;
  public w9AuthorizationDate: Date;

  public authorizedPaymentId = '';
  public authorizedPaymentTo = '';
  public authorizedPaymentSubmitted = false;

  public permitPlanTypeOptions: IOptions[] = {} as IOptions[];
  public receiptsEngineeredTypeOptions: IOptions[] = {} as IOptions[];
  public receiptsRetrofitTypeOptions: IOptions[] = {} as IOptions[];

  public viewApprovalTask = 0;
  public isreadonly = false;
  public w9message = '';
  constructor(
    private readonly deviceService: DeviceDetectorService,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly apiApplicationPayment: ApplicationPaymentApiService,
    private readonly apiApplicationEvent: ApplicationEventApiService,
    private readonly apiContractor: ContractorApiService,
    private readonly apiContact: ContactApiService,
    private readonly apiHelp: HelpApiService,
    private readonly dialogW9: MatDialog,
    private readonly dialogPaf: MatDialog,
    private readonly dialogSubmit: MatDialog,
    private readonly dialogConfirmSubmit: MatDialog,
    private readonly infoSheet: MatBottomSheet,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getOwnerContactInfo();
    this.getContractorContactInfo();
    this.refreshData();
  if ((this.application.sGStatus > 0)&&(
        this.application.sGStatus === 700000001 ||
        this.application.sGStatus === 700000002 ||
        this.application.sGStatus === 700000003 ||
        this.application.sGStatus === 700000004
      ) ){

        this.w9message = this.getHelpText('w9sgmessage');

      }else{
         this.w9message = this.getHelpText('w9mainmessage');
      }
    if (this.application.stateCode === 1) {
      this.isreadonly = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadApprovalTaskData();
    this.focusApprovalTask();
    setTimeout(() => this.checkIfReadyForSubmission());
  }

  private refreshData(): void {
    this.getApplicationPaymentId();
    this.loadContractorTaskData();
    this.loadApprovalTaskData();
    this.focusApprovalTask();
    const indexPlanTypeOptions = this.listOptionSets.findIndex(
      i => i.name === 'cea_application_cea_permitplancode'
    );
    this.permitPlanTypeOptions = [
      ...this.listOptionSets[indexPlanTypeOptions].options
    ];
    const indexRetrofitOptions = this.listOptionSets.findIndex(
      i => i.name === 'cea_retrofittype'
    );
    this.receiptsRetrofitTypeOptions = [
      ...this.listOptionSets[indexRetrofitOptions].options
    ];
    const indexEngineeredOptions = this.listOptionSets.findIndex(
      i => i.name === 'cea_isengineeredsolution'
    );
    this.receiptsEngineeredTypeOptions = [
      ...this.listOptionSets[indexEngineeredOptions].options
    ];
  }

  private getApplicationPaymentId(): void {
    if(this.isHomeowner() && this.application !== undefined){
    this.apiApplicationPayment
      .getApplicationPayment(this.application.id)
      .subscribe(
        _data => {
          var data = cloneDeep(_data);
          if (data) {
            this.w9FormId = data.id;
            this.w9FormPayee = data.w9FullName;
            this.w9FormSubmitted = true;
            this.w9AuthorizationDate = data.w9AuthorizationDate;

            this.authorizedPaymentId = data.id;
            this.applicationPayment = data;
            if (this.application.paymentDataSubmitted) {
              this.authorizedPaymentTo = data.pafFullName;
              this.authorizedPaymentSubmitted = true;
            }
          } else {
            this.w9FormSubmitted = false;
          }
        },
        err => console.warn(`PreRetrofit.checkFormData() - ${err}`)
      );
  }}

  /**********************************************
   * Owner
   */

  private getOwnerContactInfo(): void {
    this.getContact(this.application._Ebb_OwnerId, 700000000);
  }

  private getContractorContactInfo(): void {
    this.getContact(this.application._Ebb_ContractorId, 700000001);
  }

  private getContact(currentId: string, typeCode: number): void {
    this.apiContact.getContact(currentId).subscribe(
      _data => {
        var data = cloneDeep(_data);
        if (typeCode === 700000000) {
          this.applicationOwner = data;
        }
        if (typeCode === 700000001) {
          this.applicationContractor = data;
        }
      },
      error => console.warn(`ERROR: UserAccount.getContact() - ${error}`)
    );
  }

  /**********************************************
   * Contractor
   */
  private loadContractorTaskData(): void {
    const taskitems = this.taskBuildingPermit.approvalTaskItems;
    const bids = taskitems.filter(
      x => x.name === 'Estimate' && x.payloadTypeCode === 700000001
    );
    if (bids.filter(x => x.statusCode === 700000002).length > 0) {
      this.taskRetrofitContractorStatus = 'rejected';
    } else {
      this.taskRetrofitContractorStatus = '';
    }

    if (
      this.application.contractorTypeCode > 0 &&
      this.taskRetrofitContractorStatus !== 'rejected'
    ) {
      // 700000000: Contractor; 700000001: Owner
      if (
        parseInt(this.application.contractorTypeCode.toString(), 10) ===
        700000000
      ) {
        if (
          this.application._Ebb_ContractorId &&
          this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId
        ) {
          this.taskRetrofitContractorStatus = 'Selected';
          this.loadContractorName(this.application._Ebb_ContractorId);
        } else {
          this.taskRetrofitContractorStatus = 'Pending';
        }
        this.taskRetrofitContractorSummary = 'Select contractor';
      } else {
        this.taskRetrofitContractorStatus = 'Selected';
        this.taskRetrofitContractorSummary = 'Homeowner';
      }
    } else {
      this.taskRetrofitContractorSummary = 'Select who will do the retrofit';
    }
  }

  private loadContractorName(id: string): void {
    // console.log('loadContractorName, id=' + id);
    this.apiContractor.getContractor(id, false).subscribe(
      _data => {
        var data = cloneDeep(_data);
        if (data === null) {
          console.log('loadContractorName, getContractor returns null');
        }
        this.taskRetrofitContractorSummary = `${data.fullName} (${
          data.businessName
        })`;
      },
      error => console.warn(error)
    );
  }

  /**********************************************
   * W-9 Data
   */

  public onClickSubmitW9data(): void {
    const dataDialog: IDataW9Form = {} as IDataW9Form;
    dataDialog.w9FullName = this.application._Ebb_OwnerId_Formatted;
    dataDialog.w9AddressStreet = this.applicationOwner.address1_Line1;
    if(this.applicationOwner.address1_Line2 != null && this.applicationOwner.address1_Line2.length >0){
      dataDialog.w9AddressStreet += " "+ this.applicationOwner.address1_Line2;
    }
    dataDialog.w9AddressCity = this.applicationOwner.address1_City;
    dataDialog.w9AddressState = this.applicationOwner.address1_StateOrProvince;
    this.applicationOwner.address1_PostalCode &&
    this.applicationOwner.address1_PostalCode.indexOf('-') > 0
      ? (dataDialog.w9AddressZip = this.applicationOwner.address1_PostalCode.split(
          '-'
        )[0])
      : (dataDialog.w9AddressZip = this.applicationOwner.address1_PostalCode);

    const dialogRef = this.dialogW9.open(DialogW9formComponent, {
      width: '400px',
      data: dataDialog
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const applicationPaymentInput: IApplicationPaymentInput = {} as IApplicationPaymentInput;
        applicationPaymentInput._Ebb_ApplicationId = this.application.id;
        applicationPaymentInput.w9FullName = dataDialog.w9FullName;
        applicationPaymentInput.w9SsnLast4 = dataDialog.w9Ssn;
        applicationPaymentInput.w9AddressStreet = dataDialog.w9AddressStreet;
        applicationPaymentInput.w9AddressCity = dataDialog.w9AddressCity;
        applicationPaymentInput.w9AddressState = dataDialog.w9AddressState;
        applicationPaymentInput.w9AddressZip = dataDialog.w9AddressZip;
        applicationPaymentInput.w9AuthorizationDate =
          dataDialog.w9AuthorizedDate;
        if (applicationPaymentInput.w9SsnLast4.startsWith('00000')) {
          delete applicationPaymentInput['w9SsnLast4'];
        }
        this.w9FormPayee = dataDialog.w9FullName;
        this.apiApplicationPayment
          .updateApplicationPayment(applicationPaymentInput, this.w9FormId)
          .subscribe(
            data => {
              this.w9FormId = cloneDeep(data);
              const applicationInput: IApplicationInput = {} as IApplicationInput;
              applicationInput.w9DataSubmitted = true;
              this.apiApplication
                .updateApplication(applicationInput, this.application.id)
                .subscribe(
                  () => {
                    this.updateW9DataTaskItem(this.taskW9form, this.w9FormId);
                  },
                  error =>
                    console.warn(`Error: onClickSubmitW9Data() - ${error}`)
                );
            },
            err => console.warn(`onClickSubmitW9Data() - ${err}`)
          );
      }
    });
  }

  private updateW9DataTaskItem(task: IApprovalTask, payloadName: string): void {
    const approvalTaskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    const nowDate: Date = new Date();
    const taskItem: IApprovalTaskItem = task.approvalTaskItems[0];
    approvalTaskItem.id = taskItem.id;
    approvalTaskItem.payloadName = payloadName;
    approvalTaskItem.submitDate = nowDate;
    if (taskItem.statusCode !== 700000003) {
      approvalTaskItem.statusCode = 700000003;
    }

    this.apiApprovalTaskItem
      .saveItem(approvalTaskItem, this.application.id, null)
      .subscribe(
        data => {
          if (task.statusCode !== 700000003) {
            task.statusCode = 700000003;
          }
          this.application.w9DataSubmitted = true;
          this.w9FormSubmitted = true;
          this.onEmitDataFormUpdate(task);
        },
        err => console.warn(`ApprovalDataForm.updateTaskItem() - ${err}`)
      );
  }

  /**********************************************
   * Payment Authorization
   */

  public onClickSubmitPaymentAuthorization(): void {
    const dataDialog: IDataPaymentAuthorizationForm = {} as IDataPaymentAuthorizationForm;
    dataDialog.applicationPayment = this.applicationPayment;
    dataDialog.applicationOwner = this.applicationOwner;
    dataDialog.applicationContractor = this.applicationContractor;
    dataDialog.applicationDweling = this.application.dwelling;
    dataDialog.programType = this.application.programType;
    const dialogRef = this.dialogPaf.open(DialogPaformComponent, {
      width: '400px',
      data: dataDialog
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const applicationPaymentInput: IApplicationPaymentInput = {} as IApplicationPaymentInput;
        applicationPaymentInput._Ebb_ApplicationId = this.application.id;
        applicationPaymentInput.pafTypeCode = dataDialog.pafTypeCode;
        this.applicationPayment.pafTypeCode = dataDialog.pafTypeCode;
        applicationPaymentInput.pafFullName = dataDialog.pafFullName;
        this.applicationPayment.pafFullName = dataDialog.pafFullName;
        applicationPaymentInput.pafAddressStreet = dataDialog.pafAddressStreet;
        applicationPaymentInput.pafAddressCity = dataDialog.pafAddressCity;
        applicationPaymentInput.pafAddressState = dataDialog.pafAddressState;
        applicationPaymentInput.pafAddressZip = dataDialog.pafAddressZip;
        applicationPaymentInput.pafAuthorizationDate =
          dataDialog.pafAuthorizationDate;
        this.authorizedPaymentTo = dataDialog.pafFullName;
        this.authorizedPaymentSubmitted = true;
        this.apiApplicationPayment
          .updateApplicationPayment(
            applicationPaymentInput,
            this.authorizedPaymentId
          )
          .subscribe(
            data => {
              
              this.authorizedPaymentId =cloneDeep(data);
              const applicationInput: IApplicationInput = {} as IApplicationInput;
              applicationInput.paymentDataSubmitted = true;
              this.apiApplication
                .updateApplication(applicationInput, this.application.id)
                .subscribe(
                  () => {
                    this.updatePafDataTaskItem(
                      this.taskPaymentAuthorization,
                      this.authorizedPaymentId
                    );
                  },
                  error =>
                    console.warn(`Error: onClickSubmitPaymentData() - ${error}`)
                );
            },
            err => console.warn(`onClickSubmitPaymentData() - ${err}`)
          );
      }
    });
  }

  private updatePafDataTaskItem(
    task: IApprovalTask,
    payloadName: string
  ): void {
    const approvalTaskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    const nowDate: Date = new Date();
    const taskItem: IApprovalTaskItem = task.approvalTaskItems[0];
    approvalTaskItem.id = taskItem.id;
    approvalTaskItem.payloadName = payloadName;
    approvalTaskItem.submitDate = nowDate;
    if (taskItem.statusCode !== 700000003) {
      approvalTaskItem.statusCode = 700000003;
    }

    this.apiApprovalTaskItem
      .saveItem(approvalTaskItem, this.application.id, null)
      .subscribe(
        data => {
          if (task.statusCode !== 700000003) {
            task.statusCode = 700000003;
          }
          this.onEmitDataFormUpdate(task);
        },
        err => console.warn(`ApprovalItemForm.updateTaskItem() - ${err}`)
      );
  }

  /**********************************************
   * Submission
   */

  private checkIfReadyForSubmission(): void {
    let itemsCount = 0,
      itemsApprovedOrSubmitted = 0;
    let formsCompleted = false;

    if (
      this.application.eventMitigationReviewSubmitted &&
      parseInt(this.application.submissionRejection?.toString(), 10) ===
        700000000
    ) {
      return;
    }

    if (
      this.isContractor() &&
      this.application.contractorPermissionsCode === 700000000
    ) {
      return;
    }

    if (
      (this.application.contractorTypeCode === 700000000 &&
        (this.application._Ebb_ContractorId &&
          this.application._Ebb_ContractorId.length > 0) &&
        this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId) ||
      this.application.contractorTypeCode === 700000001
    ) {
      itemsCount++;
      itemsApprovedOrSubmitted++;
    } else {
      itemsCount++;
    }

    this.application.approvalTasks.forEach(task => {
      if (task.stageCode === this.application.stageCode) {
        task.approvalTaskItems.forEach(item => {
          if (item.statusCode === 700000001 || item.statusCode === 700000003) {
            itemsCount++;
            itemsApprovedOrSubmitted++;
          } else {
            itemsCount++;
          }
        });
      }
    });

    // check if data for forms have been submitted
    this.application.retrofitConstructionStartDate &&
    (this.application.permitIssuer &&
      this.application.permitIssuer.length > 0) &&
    (this.application.inspectorFullname &&
      this.application.inspectorFullname.length > 0) &&
    (this.application.permitCost && this.application.permitCost > 0)
      ? (formsCompleted = true)
      : (formsCompleted = false);

    if (
      itemsCount === itemsApprovedOrSubmitted &&
      formsCompleted &&
      this.application.itemsRejectedRollup <= 0
    ) {
      this.emitSubmitApplication.emit(true);
      this.openSubmitDialog();
    }
  }

  public openSubmitDialog(): void {
    const dialogRef = this.dialogSubmit.open(DialogSubmitComponent, {
      width: '300px',
      data: {
        userIsHomeowner: this.isHomeowner(),
        application: this.application,
        submitApplication: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      let isResubmit = false;
      if (result && result === 'yes') {
        const applicationInput: IApplicationInput = {} as IApplicationInput;
        applicationInput.eventApplicationSubmitted = true;
        applicationInput.submissionRejection = 700000000;
        applicationInput.itemsRejectedtotal = 0;
        const markitems: IApprovalTaskItem[] = [];
        this.application.approvalTasks.forEach(task => {
          task.approvalTaskItems.forEach(item => {
            markitems.push(item);
          });
        });

        this.apiApplication
          .updateApplication(applicationInput, this.application.id)
          .subscribe(
            data => {
              isResubmit = this.MarkItems(markitems, isResubmit);
            },
            error => console.warn(error)
          );
      }
    });
  }

  private MarkItems(markitems: IApprovalTaskItem[], isResubmit: boolean) {
    markitems
      .filter(item => item.submissionReject !== 0)
      .forEach(item => {
        const itemEdit: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
        itemEdit.id = item.id;
        itemEdit.submissionReject = 0;
        this.apiApprovalTaskItem
          .saveItem(itemEdit, this.application.id, item._Ebb_ApprovalTaskId)
          .subscribe();
        if (item.submissionReject && item.submissionReject !== 0) {
          isResubmit = true;
        }
      });
    const dialogViewDataItem = { wasResubmit: isResubmit };
    const dialogRefConfirm = this.dialogConfirmSubmit.open(
      DialogConfirmSubmissionComponent,
      { width: '300px', data: dialogViewDataItem }
    );
    dialogRefConfirm.afterClosed().subscribe(result => {
      this.router.navigate(['home']);
    });
    return isResubmit;
  }

  /**********************************************
   * Emit
   */

  public onEmitContractorUpdate(input: IApplicationInput) {
    this.emitEventContractorChange.emit(input);
    this.loadContractorTaskData();
  }

  public onEmitPermitUpdate(input: IApplicationInput) {
    this.emitPermitInfoChangeEvent.emit(input);
  }
  public onEmitReceiptsPreInfoUpdate(input: IApplicationInput) {
    this.emitReceiptsPreInfoChangeEvent.emit(input);
  }

  public onEmitFileUploadEvent(task: IApprovalTask) {
    this.emitFileChangeEvent.emit(task);
  }
  public onEmitContractorFileUploadEvent(task: IApprovalTask) {
    this.taskBuildingPermit = task;
    this.emitFileChangeEvent.emit(task);
    this.loadContractorTaskData();
  }
  public onEmitDataFormUpdate(task: IApprovalTask) {
    this.emitDataFormChangeEvent.emit(task);
  }

  public onEmitTimeSpanFormUpdate(task: IApprovalTask) {
    this.updateTimeSpanTaskItems(task);
  }

  private updateTimeSpanTaskItems(task: IApprovalTask): void {
    const taskItemConstruction1: IApprovalTaskItem = task.approvalTaskItems.find(x => x.name === 'Construction');
    const taskItemConstruction2: IApprovalTaskItem = task.approvalTaskItems.find(x => x.name === 'Construction Time Span');
    const taskItemConstruction: IApprovalTaskItem = taskItemConstruction2 !== undefined ? taskItemConstruction2 : taskItemConstruction1;
    
    const taskItemInspection: IApprovalTaskItem = task.approvalTaskItems.find(
      x => x.name === 'Inspection'
    );
    const nowDate: Date = new Date();
    const taskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    taskItem.submitDate = nowDate;
    taskItem.statusCode = 700000003; //Updated

    if (
      taskItemConstruction.payloadName === 'dirty' &&
      taskItemInspection.payloadName === 'dirty'
    ) {
      this.updateTimeSpanTaskItemsBoth(
        task,
        taskItem,
        taskItemConstruction.id,
        taskItemInspection.id
      );
    } else if (taskItemConstruction.payloadName === 'dirty') {
      this.updateTimeSpanTaskItemsOne(task, taskItem, taskItemConstruction.id);
    } else {
      this.updateTimeSpanTaskItemsOne(task, taskItem, taskItemInspection.id);
    }
  }

  private updateTimeSpanTaskItemsBoth(
    task: IApprovalTask,
    taskItem: IApprovalTaskItemInput,
    id1: string,
    id2: string
  ): void {
    taskItem.id = id1;
    this.apiApprovalTaskItem
      .saveItem(taskItem, this.application.id, null)
      .subscribe(
        data => {
          taskItem.id = id2;
          this.apiApprovalTaskItem
            .saveItem(taskItem, this.application.id, null)
            .subscribe(
              rtn => {},
              er => {
                console.warn(
                  `PostretrofitComponent.updateTimeSpanTaskItemsBoth('Inspection') - ${er}`
                );
              },
              () => {
                this.emitDataFormChangeEvent.emit(task);
              }
            );
        },
        err => {
          console.warn(
            `PostretrofitComponent.updateTimeSpanTaskItemsBoth('Construction') - ${err}`
          );
        }
      );
  }

  private updateTimeSpanTaskItemsOne(
    task: IApprovalTask,
    taskItem: IApprovalTaskItemInput,
    id1: string
  ): void {
    taskItem.id = id1;
    this.apiApprovalTaskItem
      .saveItem(taskItem, this.application.id, null)
      .subscribe(
        success => {
          this.emitDataFormChangeEvent.emit(task);
        },
        err => {
          console.warn(
            `PostretrofitComponent.updateTimeSpanTaskItemsOne() - ${err}`
          );
        }
      );
  }

  /**********************************************
   * Expansion Panel
   */
  private loadApprovalTaskData(): void {
    const approvalTaskListPre = this.application.approvalTasks.filter(
      (task: IApprovalTask) => (task.stageCode === 700000000) !== false
    );
    // console.log(`loadApprovalTaskData: ${JSON.stringify(approvalTaskList)}`)
    // 700000000: Permit; 700000001: House; 700000002: CrawlSpace; 700000004: Payment;
    approvalTaskListPre.forEach(task => {
      switch (parseInt(task.uiTabName, 10)) {
        case 700000000:
          this.taskBuildingPermit = task;
          break;
        case 700000001:
          this.taskHousePhotosPre = task;
          break;
        case 700000002:
          this.taskCrawlspacePhotosPre = task;
          break;
          case 700000004:
            this.taskReceiptsPre = task;
            break;
        case 700000005:
          this.taskW9form = task;
          break;
      }
    });

    const approvalTaskListPost = this.application.approvalTasks.filter(
      (task: IApprovalTask) => (task.stageCode === 700000001) !== false
    );
    // console.log(`Permit: ${JSON.stringify(approvalTaskList)}`);
    // 700000000: Permit; 700000001: House; 700000002: CrawlSpace;
    // 700000003: Heater; 700000004: Receipt; 700000005: Payment;
    approvalTaskListPost.forEach(task => {
      switch (parseInt(task.uiTabName, 10)) {
        case 700000000:
          this.taskPermitSignoff = task;
          break;
        case 700000001:
          this.taskHousePhotosPost = task;
          this.programHasHousePhotos = true;
          break;
        case 700000002:
          this.taskCrawlspacePhotosPost = task;
          break;
        case 700000003:
          this.taskHeaterPhotos = task;
          break;
        case 700000004:
          this.taskReceiptsPost = task;
          break;
        case 700000005:
          this.taskPaymentAuthorization = task;
          break;
      }
    });
  }

  private focusApprovalTask(): void {
    const isMobile = this.deviceService.isMobile();
    this.setApprovalTask(-1);
    console.log(`Begin focusApprovalTask`);
    if (this.taskBuildingPermit.statusCode === 700000002) {
      this.setApprovalTask(1);
    } else if (this.taskPermitSignoff.statusCode === 700000002) {
      this.setApprovalTask(2);
    } else if (this.taskHousePhotosPre.statusCode === 700000002) {
      this.setApprovalTask(3);
    } else if (
      this.taskHousePhotosPost &&
      this.taskHousePhotosPost.statusCode === 700000002
    ) {
      this.setApprovalTask(4);
    } else if (this.taskCrawlspacePhotosPre.statusCode === 700000002) {
      this.setApprovalTask(5);
    } else if (this.taskCrawlspacePhotosPost.statusCode === 700000002) {
      this.setApprovalTask(6);
    } else if (this.taskHeaterPhotos.statusCode === 700000002) {
      this.setApprovalTask(7);
    }  else if (this.taskReceiptsPre && this.taskReceiptsPre.statusCode === 700000002) {
      this.setApprovalTask(8);
    }else if (this.taskReceiptsPost.statusCode === 700000002) {
      this.setApprovalTask(9);
    } 
   else if (this.taskW9form && this.taskW9form.statusCode === 700000002) {
      this.setApprovalTask(10);
    } else if (this.taskPaymentAuthorization.statusCode === 700000002) {
      this.setApprovalTask(11);
    }
    console.log(`End focusApprovalTask`);
  }

  public loadTaskStatusIconHtml(type: string, status: number): string {
    var check_box_outline_blank = 'fa-solid fa-square-poll-horizontal fa-sm';
    let iconName = check_box_outline_blank;
    var checkbox ='fa-solid fa-square-check fa-sm';
    var warning ='fa-solid fa-triangle-exclamation fa-sm';
    switch (status) {
      case 700000000:
        iconName = check_box_outline_blank;
        break;
      case 700000001:
        iconName = checkbox;
        break;
      case 700000002:
        iconName =warning;
        break;
      case 700000003:
        iconName = checkbox;
        if (type === 'permit') {
          if (!this.application.permitNumber)
            iconName = check_box_outline_blank;
        }
        break;
    }
    return "<i class='"+iconName+"'/>";
  }

  public loadTaskStatusValue(type: string, status: number): string {
    let statusDisplay = '';
    switch (status) {
      case 700000000:
        statusDisplay = 'Waiting for information';
        break;
      case 700000001:
        statusDisplay = 'Under Review (In Process)';
        break;
      case 700000002:
        statusDisplay = 'Action required';
        break;
      case 700000003:
        statusDisplay = 'Under Review (In Process)';
        break;
    }
    return statusDisplay;
  }

  public setApprovalTask(index: number): void {
    this.viewApprovalTask = index;
    switch (index) {
      case 0:
        this.apiHelp.setCurrentHelpTopicValue('Construction');
        break;
      case 1:
        this.apiHelp.setCurrentHelpTopicValue('Permit');
        break;
      case 2:
      case 3:
        this.apiHelp.setCurrentHelpTopicValue('Photo');
        break;
    }
  }

  public nextApprovalTask(): void {
    this.programHasHousePhotos && this.viewApprovalTask === 0
      ? this.viewApprovalTask++
      : (this.viewApprovalTask = this.viewApprovalTask + 2);
  }

  public prevApprovalTask(): void {
    this.programHasHousePhotos && this.viewApprovalTask === 2
      ? this.viewApprovalTask--
      : (this.viewApprovalTask = this.viewApprovalTask - 2);
  }

  public lookupOptions(name: string): IOptions[] {
    return this.listOptionSets.filter(i => i.name === name)[0].options;
  }

  /**********************************************
   * Help
   */
  public helpByTopic(topic: string) {
    return this.listHelp.filter(
      i => i.topicCodeOptionSet.toLowerCase() === topic.toLowerCase()
    );
  }

  public onClickShowHelp(item: IHelp): void {
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }
  private getHelpText(name: string): string {
    let message = '';
    const index = this.listHelp.findIndex(i => i.name.toLowerCase() === name);
    if (index >= 0) message = this.listHelp[index].answer;

    return message;
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
